import { render, staticRenderFns } from "./AmountDetailesEditor.vue?vue&type=template&id=0041672d&"
import script from "./AmountDetailesEditor.vue?vue&type=script&lang=js&"
export * from "./AmountDetailesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports